import { render, staticRenderFns } from "./journal-detail.vue?vue&type=template&id=a75095ac"
import script from "./journal-detail.vue?vue&type=script&lang=js"
export * from "./journal-detail.vue?vue&type=script&lang=js"
import style0 from "./journal-detail.vue?vue&type=style&index=0&id=a75095ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports